import { useLazyQuery, useMutation } from '@apollo/client';
import { Button, Card, Form } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import { DATE_FORMATS, ROUTES } from '../../../../../common/constants';
import { formatDate } from '../../../../../common/utils';
import GoBackButton from '../../../../../components/GoBackButton';
import LoaderComponent from '../../../../../components/LoaderComponent';
import Portal from '../../../../../components/Portal';
import { UPDATE_USER } from '../../../graphql/Mutations';
import { USER } from '../../../graphql/Queries';
import AmbassadorForm from '../components/AmbassadorForm';

const EditAmbassador = (props) => {
  const { match: { params: { id } = {} } = {} } = props;

  const history = useHistory();
  const [form] = Form.useForm();
  const { dispatch } = useContext(AppContext);
  const [ambassadorDetail, setAmbassadorDetail] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isAmbassadorLoading, setIsAmbassadorLoading] = useState(true);

  const [updateUser] = useMutation(UPDATE_USER, {
    onError: () => { },
  });

  const [users] = useLazyQuery(USER, {
    onCompleted: (response) => {
      setAmbassadorDetail(response?.user);
      setIsAmbassadorLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() { },
  });

  useEffect(() => {
    setIsAmbassadorLoading(true);
    setAmbassadorDetail([]);
    users({
      variables: {
        where: {
          id,
        },
      },
    });
  }, []);

  const updateAmbassadorFun = async (ambassadorDetails) => {
    setIsSubmitLoading(true);
    dispatch({
      type: 'SET_SHOW_PROMPT',
      data: false,
    });

    // Split name into first and last name
    const nameParts = ambassadorDetails?.name?.trim()?.split(' ');
    const firstName = nameParts?.[0] || '';
    const lastName = nameParts?.slice(1)?.join(' ') || '';

    const response = await updateUser({
      variables: {
        where: {
          id,
        },
        data: {
          firstName,
          lastName,
          gender: ambassadorDetails?.gender,
          city: ambassadorDetails?.city,
          state: ambassadorDetails?.state,
          roles: ['AMBASSADOR'],
          contactNo: ambassadorDetails?.contact?.trim(),
          address: ambassadorDetails?.address?.trim(),
          address2: ambassadorDetails?.address2?.trim(),
          locality: ambassadorDetails?.locality?.trim(),
          landmark: ambassadorDetails?.landmark?.trim(),
          email: ambassadorDetails?.email?.trim(),
          pincode: ambassadorDetails?.pincode,
          isAmbassadorActive: ambassadorDetails?.isAmbassadorActive,
        },
      },
    });
    if (response?.data) {
      history?.replace(`${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}`);
    }
    setIsSubmitLoading(false);
  };

  const handleShowPrompt = () => {
    setIsDisabled(false);
    dispatch({
      type: 'SET_SHOW_PROMPT',
      data: true,
    });
  };

  const initialValues = {
    ...ambassadorDetail,
    name: `${ambassadorDetail?.firstName || ''} ${ambassadorDetail?.lastName || ''}`.trim(),
    contact: ambassadorDetail?.contactNo,
    role: ambassadorDetail?.roles?.[0],
    gender: ambassadorDetail?.gender,
    pincode: ambassadorDetail?.pincode?.pincode,
    isAmbassadorActive: ambassadorDetail?.isAmbassadorActive,
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton customLink={ROUTES?.SYSTEM_USERS} />
        <div className="portal-header">Edit Ambassador</div>
      </Portal>
      <Portal portalId="header-right-content">
        <div className="header-btn-wrapper">
          <Button
            type="primary"
            className="common-button mr-16"
            size="middle"
            onClick={() =>
              history?.push(`${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}`)
            }
          >
            Discard Changes
          </Button>
          <Button
            className="common-button"
            size="middle"
            onClick={form.submit}
            loading={isSubmitLoading}
            disabled={isDisabled}
          >
            Save
          </Button>
        </div>
      </Portal>
      <Portal portalId="header-right-content-phones">
        <div className="header-btn-wrapper">
          <Button
            type="primary"
            className="common-button mr-16"
            size="middle"
            onClick={() =>
              history?.push(`${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}`)
            }
          >
            Discard Changes
          </Button>
          <Button
            className="common-button"
            size="middle"
            onClick={form.submit}
            loading={isSubmitLoading}
            disabled={isDisabled}
          >
            Save
          </Button>
        </div>
      </Portal>
      <Card
        className="full-height-with-nav"
        title="Ambassador Details"
        extra={
          <strong>
            Onboarded On :{' '}
            {formatDate(ambassadorDetail?.createdAt, DATE_FORMATS?.ONBOARD)}
          </strong>
        }
      >
        {isAmbassadorLoading ? (
          <LoaderComponent
            size="large"
            setHeight="60"
            spinning={isAmbassadorLoading}
          />
        ) : (
          <div className="admin-form">
            <AmbassadorForm
              form={form}
              onFinish={updateAmbassadorFun}
              handleShowPrompt={handleShowPrompt}
              initialValues={initialValues}
              ambassadorDetail={ambassadorDetail}
            />
          </div>
        )}
      </Card>
    </>
  );
};

export default EditAmbassador;
